export default "<h1>{{message}}</h1>\r\n"